package pro.jayeshseth.animations.core.ui.utils

import androidx.compose.runtime.Composable

@Composable
actual fun TrackRecomposition(trackMap: Map<String, Any?>, composableName: String) {}

actual fun initRebugger() {}
